import { Text2, skinVars } from '@telefonica/mistica';
import React from 'react';
import './index.scss';

export interface ChatTextData {
    context: 'answer' | 'response';
    text: string;
    html?: boolean;
}

export const ChatText: React.FC<ChatTextData> = ({ context, text, html }: ChatTextData) => {
    return (
        <div className='chatText'>
            {context === 'answer' && (
                <div className='chatText__answer'>
                    <Text2 regular>{html ? <span dangerouslySetInnerHTML={{ __html: text }}></span> : text}</Text2>
                </div>
            )}
            {context === 'response' && (
                <div className='chatText__response'>
                    <span
                        className='chatText__response-span'
                        style={{ background: skinVars.colors.buttonLinkBackgroundPressed }}
                    >
                        <Text2 regular>{text}</Text2>
                    </span>
                </div>
            )}
        </div>
    );
};

export default ChatText;
